import styles from './WhiteButton.module.scss'

const WhiteButton = ({ children, onClick }) => {
  return (
    <button className={styles.pageCardBtn} onClick={onClick}>{children}</button>
  );
};

export default WhiteButton;